import { MasterDocumentsTable } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/components/MasterDocumentsTable/MasterDocumentsTable.tsx';
import { MasterDocumentsScopeProvider } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/MasterDocumentsScopeContext.tsx';
import { StyledSettingsContainer } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/styles.ts';

// No organizationId: this is the programme tier, whose ids come from the route.
export const MasterDocuments = () => (
	<StyledSettingsContainer>
		<MasterDocumentsScopeProvider>
			<MasterDocumentsTable />
		</MasterDocumentsScopeProvider>
	</StyledSettingsContainer>
);
